import { Component } from '@angular/core';
import {  NavParams, ToastController, ViewController } from 'ionic-angular';
import { TournamentService } from '../../../services/tournament.service';
import { SportAlgoUtils } from '../../../services/sport.algo';

@Component({
  selector: 'edit-one-page',
  templateUrl: 'edit-one-page.html',
})
export class ResultEditOnePage {
  pareIndex: any;
  activePlan: any;
  ti: any;
  results = ["0", "0"];
  points =  ["0", "0"];
  changeDetector: boolean = false;

  constructor(
    private navParams: NavParams,
    private toastCtrl: ToastController,
    private viewCtrl: ViewController,
    public gs: TournamentService
    ) { }

  ionViewDidLoad() {
    this.ti = this.navParams.get('teamIndex');
    this.activePlan = this.navParams.get('activePlan');
    this.results = this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i].results.split('-');
    this.points = this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i].points.split('-')
  }

  onChangeTeam(index){
    this.toastCtrl.create({
      duration: 5000,
      position: 'top',
    }).present();
  }

  teamClick(winnerIndex: number){
    this.points[winnerIndex] = this.gs.counters.winScore + "";
    this.onSetWinner(winnerIndex);
  }
  
  onSave(){
    this.gs.save();
  }

  onResultChange(index: number, value: any){
    value = Number(value);
    if(value >= 0){
      let winner = this.getWinner();    
      this.points[0] = this.getMultiplicator(winner, 1) + "";
      this.points[1] = this.getMultiplicator(winner, 2) + "";
      this.onPointsChange(winner - 1);
    }
  }

  onPointsChange(winner: number = -1){
    this.onSetWinner(winner);
  }

  onSetWinner(winnerIndex: number){
    this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i].winner = winnerIndex;
    this.changeDetector = true;
    this.gs.save();
  }

  getWinner(){
    if(this.results[0] > this.results[1]){
      return 1;
    }else if(this.results[0] < this.results[1]){
      return 2;
    }else{
      return 0;
    }
  }

  getMultiplicator(winner, team){
   if(winner == 0) return this.gs.counters.tieScore;
    if(team == 1){
      return (winner == 1)?  this.gs.counters.winScore: this.gs.counters.lossScore; 
    }else if(team == 2){
      return (winner == 2)?  this.gs.counters.winScore: this.gs.counters.lossScore; 
    }
  }

  update(){
    this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i].team1.points += Number(this.points[0]);      
    this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i].team2.points += Number(this.points[1]);;      
    this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i].team1.results += Number(this.results[0]);     
    this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i].team2.results += Number(this.results[1]);     
    this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i].points = this.points[0] + "-" + this.points[1];
    this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i].results = this.results[0] + "-" + this.results[1];
    this.gs.save();
    this.gs.saveGamePair(this.gs.planList[this.activePlan].gameTable[this.ti.r][this.ti.i]).then(() => {
      this.gs.loadTou(this.gs.planList[this.activePlan].id).then(plan =>{
        this.gs.planList[this.activePlan] = plan;
      });
    });
  }


  onClose(){
    if(this.changeDetector) this.update();
    this.viewCtrl.dismiss();
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/edits/one-page/edit-one-page.ts